import { cn } from '@/lib/utils';

/**
 * Skeleton — flat static gray bar. No shimmer. Per Tier 6.1: shimmer
 * animations add visual noise without communicating anything useful, so
 * Cleanlist's skeletons are just static muted rectangles. A very gentle
 * pulse would be acceptable but we default to flat for maximum calm.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-md bg-muted/60', className)} {...props} />;
}

export { Skeleton };
